import React from 'react';
import { Aug2022, Holi2022, Nov2022, Oct2023, Aug2024 } from './imports';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import './event.css';
import './upcomingevent.css';

const AllEvents = () => {
  return (
    <section className="gpt3__events section__padding" id="events">
      <div className="gpt3__events-heading">
        <p className="gpt3__events-kicker">Live. Celebrate. Perform.</p>
        <h2 className="gradient__text">Our Events</h2>
        <p className="gpt3__events-subtitle">A journey of performances, milestones, and community moments.</p>
      </div>

      <Carousel className="gpt3__events-carousel" useKeyboardArrows showThumbs={false} showStatus={false} infiniteLoop>
      <article className="gpt3__event gpt3__event--slide">
      <div className="gpt3__event-content">
       <h3 className="gradient__text gpt3__event-title">
       FIDO-Rogers Diwali commercial feature</h3>
        <p className="gpt3__event-description">Bollywood Ki Dhun star Shwayta Sharma got an opportunity to participate in the FIDO-Rogers Diwali commercial. We are proud and congratulate her on this milestone achievement.</p>
      </div>

    <div className="gpt3__event-image">
          <iframe
            src="https://www.youtube.com/embed/02Lfj6Y5Nl0?si=NG5O42x0cnSiVaDH"
            title="FIDO-Rogers Diwali Commercial"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </article>

      <article className="gpt3__event gpt3__event--slide">
      <div className="gpt3__event-content">
       <h3 className="gradient__text gpt3__event-title">78th Independence Day of India</h3>
        <p className="gpt3__event-description">We proudly hosted our event to celebrate India&apos;s 78th Independence Day. Thank you to everyone who joined and made the evening memorable.</p>
      </div>

    <div className="gpt3__event-image">
          <img src={Aug2024} alt="78th Independence Day event poster" />
        </div>
      </article>


    <article className="gpt3__event gpt3__event--slide">
        <div className="gpt3__event-content">
       <h3 className="gradient__text gpt3__event-title">Diwali Celebration 2023</h3>
        <p className="gpt3__event-description">Our Diwali event was warmly appreciated by attendees for its music, atmosphere, and performances.</p>
      </div>

    <div className="gpt3__event-image">
          <img src={Oct2023} alt="Diwali 2023 event poster" />
        </div>
      </article>

     <article className="gpt3__event gpt3__event--slide">
        <div className="gpt3__event-content">
       <h3 className="gradient__text gpt3__event-title">Retro Reels</h3>
        <p className="gpt3__event-description">Retro Reels was a huge success, featuring songs from Bollywood&apos;s golden era and unforgettable nostalgia.</p>
      </div>

    <div className="gpt3__event-image">
          <img src={Nov2022} alt="Retro Reels event poster" />
        </div>
      </article>

    <article className="gpt3__event gpt3__event--slide">
        <div className="gpt3__event-content">
        <h3 className="gradient__text gpt3__event-title">Kishore Da Tribute</h3>
        <p className="gpt3__event-description">A special tribute event celebrating the birth anniversary of the legendary Kishore Da with heartfelt performances.</p>
      </div>

    <div className="gpt3__event-image">
          <img src={Aug2022} alt="Kishore Da tribute event poster" />
        </div>
      </article>

     <article className="gpt3__event gpt3__event--slide">
        <div className="gpt3__event-content">
        <h3 className="gradient__text gpt3__event-title">Holi Celebration 2022</h3>
        <p className="gpt3__event-description">Our Holi 2022 celebration brought color, music, and community together in a vibrant musical evening.</p>
      </div>

    <div className="gpt3__event-image">
          <img src={Holi2022} alt="Holi 2022 event poster" />
        </div>
      </article>
      </Carousel>
    </section>
  )
}

export default AllEvents
